import { TRACKING_TABS } from '../../../../data/tracking/trackingData';

const TrackingTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="w-full mb-4 sm:mb-6 animate-in fade-in duration-200">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 w-full">
        {TRACKING_TABS.map((tab, idx) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const isLastTab = idx === TRACKING_TABS.length - 1;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              className={`w-full flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3.5 rounded-xl sm:rounded-2xl text-xs sm:text-sm font-bold sm:font-bold capitalize tracking-normal transition-all cursor-pointer ${
                isLastTab ? 'col-span-2 sm:col-span-1' : 'col-span-1'
              } ${
                isActive
                  ? 'bg-[#067978] text-white shadow-md shadow-[#067978]/20 ring-2 ring-[#067978]'
                  : 'bg-white text-slate-500 hover:text-slate-900 hover:bg-slate-50 border border-slate-200/60 shadow-2xs'
              }`}
            >
              <Icon size={16} className="shrink-0" />
              <span className="truncate">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TrackingTabs;
